const dataValuationMethodo = [
  {
    type: 'EV/EBITDA',
    cout: 18
  },
  {
    type: 'FCF Yield',
    cout: 13
  },
  {
    type: 'DCF',
    cout: 19
  },
  {
    type: 'EV/EBITA',
    cout: 1
  },
  {
    type: 'EV/Revenues',
    cout: 16
  }
];

export default dataValuationMethodo;
